// eslint-disable-next-line
function isEmptyObject(obj) {
    return Object.values(obj).every((val) => typeof val === 'undefined');
}
export { isEmptyObject };
